import Image from 'next/image';
import Link from 'next/link';
import { type FC } from 'react';

import {
  getOfferingPackagePriceLabel,
  getPlanCustomerPageUrl,
} from '../../../../utils/package';
import CheckboxInput from '../../../inputs/CheckboxInput';

import { type PackageSelectionCoachFragment } from './__generated-gql-types__/PackageSelection.generated';
import { type PackageSelectionCardOfferingPackageFragment } from './__generated-gql-types__/PackageSelectionCard.generated';

interface PackageSelectionCardProps {
  isSelected: boolean;
  coach: PackageSelectionCoachFragment;
  onSelect: (selected: boolean) => void;
  offeringPackage: PackageSelectionCardOfferingPackageFragment;
}

export const PackageSelectionCard: FC<PackageSelectionCardProps> = ({
  isSelected,
  coach,
  onSelect,
  offeringPackage,
}) => {
  const priceLabel = getOfferingPackagePriceLabel(offeringPackage.prices);

  return (
    <button
      type="button"
      className={`flex overflow-hidden rounded-lg ${isSelected ? 'border-2 border-leland-gray-dark p-4' : 'border p-[17px]'} bg-leland-white`}
      onClick={() => onSelect(!isSelected)}
    >
      <div className="flex grow flex-col items-start text-left">
        {offeringPackage.imageLink ? (
          <Image
            className="aspect-entity-image w-20 shrink-0 grow-0 object-cover"
            src={offeringPackage.imageLink}
            alt={offeringPackage.name}
            width={191}
            height={100}
          />
        ) : null}
        <h3 className="mt-4 text-lg font-medium">{offeringPackage.name}</h3>
        <div className="flex gap-1">
          <span className="text-leland-gray-light">{priceLabel} &middot; </span>
          {offeringPackage.category ? (
            <Link
              className="font-medium underline underline-offset-2"
              href={getPlanCustomerPageUrl({
                categorySlug: offeringPackage.category?.slug,
                packageSlug: offeringPackage.slug,
                coachId: coach?.id,
                coachTier: coach?.tier,
              })}
              target="_blank"
              onClick={(e) => {
                e.stopPropagation();
              }}
              id="schedule_modal_interested_packages--package_details"
            >
              Details
            </Link>
          ) : null}
        </div>
      </div>
      <div>
        <CheckboxInput
          checkboxClassName="mr-0"
          label="Selected"
          labelClassName="hidden"
          isChecked={isSelected}
          onToggle={onSelect}
        />
      </div>
    </button>
  );
};
